export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-2xl text-primary-400 mb-4 block">51漫画</span>
            <p className="text-sm text-background-400 leading-relaxed">
              51漫画是国内领先的免费漫画下载与在线阅读平台，收录超过5万部漫画作品，支持离线下载、手机客户端安装，随时随地畅享漫画全集免费阅读。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-background-100 text-sm mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门榜单</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#app" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">APP下载</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-100 text-sm mb-4">内容分类</h4>
            <ul className="space-y-2">
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">漫画分类</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">推荐漫画</a></li>
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">精选专题</a></li>
              <li><a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">漫画视频</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-100 text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
            <div className="mt-4">
              <h4 className="font-semibold text-background-100 text-sm mb-3">关注我们</h4>
              <div className="flex gap-3">
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
                <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-live-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2018-2026 51漫画 版权所有 | 51漫画免费下载，漫画全集离线阅读
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#contact" className="hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}